import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchProjectManagers: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectManager/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_PROJECTMANAGER_REQUEST,
                        types.SEARCH_PROJECTMANAGER_SUCCESS,
                        types.SEARCH_PROJECTMANAGER_FAILURE
                    ]
                }
            });
        },

    saveProjectManager: (projectManager) =>
        (dispatch) => {
            if (projectManager.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'projectManager/create',
                        method: 'POST',
                        body: projectManager,
                        types: [
                            types.CREATE_PROJECTMANAGER_REQUEST,
                            types.CREATE_PROJECTMANAGER_SUCCESS,
                            types.CREATE_PROJECTMANAGER_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'projectManager/update',
                        method: 'PUT',
                        body: projectManager,
                        types: [
                            types.UPDATE_PROJECTMANAGER_REQUEST,
                            types.UPDATE_PROJECTMANAGER_SUCCESS,
                            types.UPDATE_PROJECTMANAGER_FAILURE
                        ]
                    }
                });
            }
        }
}
